import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { USER_ROLES } from '../types';

export const useUserRolesStore = defineStore('user-roles', () => {
  const userRoles = ref<typeof USER_ROLES[keyof typeof USER_ROLES][]>([]);

  const hasPartnerRole = computed(() => userRoles.value.includes(USER_ROLES.PARTNER));
  const hasManagerRole = computed(() => userRoles.value.includes(USER_ROLES.MANAGER));

  return {
    userRoles,
    hasPartnerRole,
    hasManagerRole,
  };
});
